import React, { useState, useEffect } from "react";
import ReactIdSwiper from "react-id-swiper";

export default (props) => {
  // //console.log(props);
  var data = props.data;
  // Swiper instance
  const [swiper, updateSwiper] = useState(null);
  // Slides current index
  const [currentIndex, updateCurrentIndex] = useState(0);
  var elePagi = ".swiper-pagination";
  if (props.page == "home-banners") {
    elePagi = ".swiper-pagination.swiper-pagination-white";
  }
  var params = {};
  // Params definition
 (props.page == "dr-carousel-unit")
    params = {
      loop: true,
        slidesPerView: "auto",
        slidesPerView: 4.5,
        spaceBetween: 20,
         breakpoints: {
        767: {
          slidesPerView: 3.5,
          spaceBetween: 10
        },
      },
      getSwiper: updateSwiper // Get swiper instance callback
    }
  

  // Manipulate swiper from outside
  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  // Add eventlisteners for swiper after initializing
  useEffect(() => {
    if (swiper !== null) {
      swiper.on("slideChange", () => updateCurrentIndex(swiper.realIndex));
    }

    return () => {
      if (swiper !== null) {
        swiper.off("slideChange", () => updateCurrentIndex(swiper.realIndex));
      }
    };
  }, [swiper]);

  return (
    <div>
      <ReactIdSwiper {...params}>
        {data.map((item, idx) => (
          (props.page == "dr-carousel-unit" ? 
            <div className="swiper-slide_feed " key={idx}>
              <div className="dietPlan_all_tools_bar">
                  <div className="dietPlan_main_content"> 
                      <img src={item.stageImage} alt={item.stageName} title={item.stageName}/>
                  </div>
                  <div className="dietPlan_heading R13_42"> {item.stageName} </div> 
              </div>
            </div>
            :
            <div className="swiper-slide_feed" key={idx}>
              <img src="https://bbcdnlivemumbai.s3.ap-south-1.amazonaws.com/brainbees/community/memoryimages/1584339297p4706331.jpeg" alt="" />
            </div>
          )
        ))}
      </ReactIdSwiper>
      <div className="buttons buttons-list" style={{ display: "none" }}>
        <button id="prevSlide" className="button is-primary" onClick={goPrev} aria-label="Previous">
          Prev
        </button>
        <button id="nextSlide" className="button is-primary" onClick={goNext} aria-label="Next">
          Next
        </button>
      </div>
    </div>
  );
};
